<template>
    <div>
        <CRow>
            <CCol>
                <div style="width:100%; height: 75vh;">
                    <ejs-grid ref='grid'
                              :dataSource='derivedCurveData'
                              :allowFiltering='true'
                              :allowPaging='true'
                              :allowResizing='true'
                              :allowReordering='true'
                              :allowSorting='true'
                              :toolbar='derivedCurveToolbar'
                              :pageSettings='pageSettings'
                              :filterSettings='filterOptions'
                              :toolbarClick='toolbarClick'
                              :allowExcelExport='true'
                              :excelExportComplete='excelExportComplete'
                              :actionBegin='actionBegin'
                              :actionComplete='actionComplete'
                              :actionFailure='actionFailure'
                              :recordDoubleClick="recordDoubleClick"
                              width="100%" height="100%">
                        <e-columns>
                            <e-column field='derivedCurveId' headerText='Id' :isPrimaryKey='true' width=120 :visible='false' type="number"></e-column>
                            <e-column field='derivedCurveIdentifier' headerText='Derived Curve Identifier' width=300 type="string"></e-column>
                            <e-column field='sourceCurveOneName' headerText='Source Curve 1' width=170 type="string"></e-column>
                            <e-column field='sourceCurveTwoName' headerText='Source Curve 2' width=170 type="string"></e-column>
                            <e-column field='sourceCurveThreeName' headerText='Source Curve 3' width=170 type="string"></e-column>
                            <e-column field='outputUnit' headerText='Output Unit' width=270 type="string"></e-column>
                            <e-column field='formula' headerText='Formula' width=270 type="string"></e-column>
                            <e-column field='stateName' headerText='Country' width=170 type="string"></e-column>
                            <e-column field='priceAreaName' headerText='Price Area' width=170 type="string"></e-column>
                            <e-column field='utilityTypeName' headerText='Commodity' width=170 type="string"></e-column>
                            <e-column field='productName' headerText='Product' width=170 type="string"></e-column>
                            <e-column field='description' headerText='Description' width=170 type="string"></e-column>
                        </e-columns>
                    </ejs-grid>
                </div>
            </CCol>
        </CRow>
    </div>
</template>

<script>
    import Vue from "vue";
    import {
        GridPlugin,
        Edit,
        Page,
        Toolbar,
        Sort,
        Filter,
        Reorder,
        Resize,
        ExcelExport,
        ForeignKey,
        CommandColumn
    } from "@syncfusion/ej2-vue-grids";
    import { Query } from '@syncfusion/ej2-data';
    import { DialogUtility } from '@syncfusion/ej2-popups';
    import gridOptions from '../../../common/gridOptions'
    import SyncHelper from '../../../common/syncfusion'
    import apis from '../../../common/network'

    Vue.use(DialogUtility);
    Vue.use(GridPlugin);
    let DialogConfirmDeleteDerivedCurve = undefined;

    export default {
        data() {
            return {

                derivedCurveData: SyncHelper.getDataManager("derivedCurve"),
                pageSettings: gridOptions.pageSettings,
                //toolbar: [{ text: 'Add', tooltipText: 'Add', prefixIcon: 'e-add', id: 'AddDerivedCurve' },
                //    { text: 'Edit', tooltipText: 'Edit', prefixIcon: 'e-edit', id: 'EditDerivedCurve' },
                //    { text: 'Delete', tooltipText: 'Delete', prefixIcon: 'e-delete', id: 'DeleteDerivedCurve' },
                //    'ExcelExport' ],
                filterOptions: gridOptions.filterSettings,
                dateFormatOptions: { type: 'date', format: 'dd/MM/yyyy', max: new Date(), params: { max: new Date() } }
            }
        },
        methods: {
            hasPermission(permission) {
                return !!this.$store.state.permissions[permission];
            },
            toolbarClick(args) {
                if (args.item.id === 'AddDerivedCurve') {
                    if (!this.hasPermission("Permissions.DerivedCurve.Create")) {
                        args.cancel = true;
                        return;
                    }
                    this.$router.push({ name: "Derived Curve Form" });
                }
                else if (args.item.id === 'EditDerivedCurve') {
                    if (!this.hasPermission("Permissions.DerivedCurve.Update")) {
                        args.cancel = true;
                        return;
                    }
                    let selectedRow = this.$refs.grid.getSelectedRecords();
                    if (selectedRow.length > 0) {
                        this.$router.push({ name: "Derived Curve Form", params: { derivedCurveId: selectedRow[0].derivedCurveId } });
                    } else {
                        DialogUtility.alert({
                            title: 'Alert Dialog',
                            content: "Please, choose a derived curve first.",
                            position: { X: 700, Y: 200 },
                            showCloseIcon: true,
                            closeOnEscape: true,
                            animationSettings: { effect: 'Zoom' },
                            zIndex: 1100
                        });
                    }
                }
                else if (args.item.id === 'DeleteDerivedCurve') {
                    if (!this.hasPermission("Permissions.DerivedCurve.Delete")) {
                        args.cancel = true;
                        return;
                    }
                    let selectedDerivedCurve = this.$refs.grid.getSelectedRecords();
                    if (selectedDerivedCurve.length > 0) {
                        DialogConfirmDeleteDerivedCurve = DialogUtility.confirm({
                            title: 'Confirm Delete',
                            content: "Are you sure you want to delete selected derived curve?",
                            position: { X: 700, Y: 200 },
                            okButton: { text: 'OK', click: this.confirmDeleteDerivedCurve },
                            cancelButton: { text: 'Cancel', click: this.cancelDeleteDerivedCurve },
                            open: () => {
                                this.$refs.focusElement.focus();
                            },
                            showCloseIcon: true,
                            closeOnEscape: true,
                        });
                    } else {
                        DialogUtility.alert({
                            title: 'Alert Dialog',
                            content: "Please, choose a derived curve first.",
                            position: { X: 700, Y: 200 },
                            showCloseIcon: true,
                            closeOnEscape: true,
                            animationSettings: { effect: 'Zoom' },
                            zIndex: 1100
                        });
                    }
                }
                if (args.item.id.indexOf("excelexport") !== -1) {
                    gridOptions.excelExport(args, "Derived Curve.xlsx", this.$refs);
                }
            },
            //toolbarClick(args) {
            //    if (args.item.id === 'AddDerivedCurve') {
            //        this.$router.push({ name: "Derived Curve Form" });
            //    }
            //    else if (args.item.id === 'EditDerivedCurve') {
            //        let selectedRow = this.$refs.grid.getSelectedRecords();
            //        if (selectedRow.length > 0) {
            //            this.$router.push({ name: "Derived Curve Form", params: { derivedCurveId: selectedRow[0].derivedCurveId } });
            //        } else {
            //            DialogUtility.alert({
            //                title: 'Alert Dialog',
            //                content: "Please, choose a derived curve first.",
            //                position: { X: 700, Y: 200 },
            //                showCloseIcon: true,
            //                closeOnEscape: true,
            //                animationSettings: { effect: 'Zoom' },
            //                zIndex: 1100
            //            });
            //        }
            //    }
            //    else if (args.item.id === 'DeleteDerivedCurve') {
            //        let selectedDerivedCurve = this.$refs.grid.getSelectedRecords();
            //        if (selectedDerivedCurve.length > 0) {
            //            DialogConfirmDeleteDerivedCurve = DialogUtility.confirm({
            //                title: 'Confirm Delete',
            //                content: "Are you sure you want to delete selected derived curve?",
            //                position: { X: 700, Y: 200 },
            //                okButton: { text: 'OK', click: this.confirmDeleteDerivedCurve },
            //                cancelButton: { text: 'Cancel', click: this.cancelDeleteDerivedCurve },
            //                open: () => {
            //                    this.$refs.focusElement.focus();
            //                },
            //                showCloseIcon: true,
            //                closeOnEscape: true,
            //            });
            //        } else {
            //            DialogUtility.alert({
            //                title: 'Alert Dialog',
            //                content: "Please, choose a derived curve first.",
            //                position: { X: 700, Y: 200 },
            //                showCloseIcon: true,
            //                closeOnEscape: true,
            //                animationSettings: { effect: 'Zoom' },
            //                zIndex: 1100
            //            });
            //        }
            //    }
            //    if (args.item.id.indexOf("excelexport") !== -1) {
            //        gridOptions.excelExport(args, "Derived Curve.xlsx", this.$refs);
            //    }
            //},

            confirmDeleteDerivedCurve: function () {
                this.$refs.grid.showSpinner();
                let selectedDerivedCurve = this.$refs.grid.getSelectedRecords();
                let derivedCurveId = selectedDerivedCurve[0].derivedCurveId;
                apis.protectedApi.delete(`derivedCurve/${derivedCurveId}`)
                    .then(response => {
                        let message = {
                            title: 'Success!',
                            content: 'Derived curve is deleted successfully.',
                            cssClass: 'e-toast-success'
                        };

                        this.$root.$emit('showToast', message);
                        this.$refs.grid.hideSpinner();
                        this.$refs.grid.refresh();
                    }).catch(e => {
                        DialogUtility.alert({
                            title: 'Alert Dialog',
                            content: e.response.data.message,
                            position: { X: 700, Y: 200 },
                            showCloseIcon: true,
                            closeOnEscape: true,
                            animationSettings: { effect: 'Zoom' },
                            zIndex: 1100
                        });
                        this.$refs.grid.hideSpinner();
                    });

                DialogConfirmDeleteDerivedCurve.hide();

            },

            cancelDeletePeriod: function () {
                DialogConfirmDeleteDerivedCurve.hide();
            },
            excelExportComplete(args) {
                this.$refs.grid.hideSpinner();
            },
            recordDoubleClick: function (e) {
                if (!this.$store.state.permissions["Permissions.DerivedCurve.Update"]) return;
                this.$router.push({ name: "Derived Curve Form", params: { derivedCurveId: e.rowData.derivedCurveId } });
            },
            actionBegin(args) {
                gridOptions.actionBegin(args);

            },
            actionComplete(args) {
                gridOptions.actionComplete(args, this.$refs);
            },
            actionFailure(args) {
                gridOptions.actionFailure(args, this.$refs);
            },
            showErrorDialog: function (message) {
                DialogUtility.alert({
                    title: 'Alert Dialog',
                    content: message,
                    position: { X: 700, Y: 200 },
                    showCloseIcon: true,
                    closeOnEscape: true,
                    animationSettings: { effect: 'Zoom' },
                    zIndex: 1100
                });
            },
        },
        computed: {
            derivedCurveToolbar() {
                return [
                    {
                        text: 'Add',
                        tooltipText: 'Add',
                        prefixIcon: 'e-add',
                        id: 'AddDerivedCurve',
                        disabled: !this.hasPermission("Permissions.DerivedCurve.Create")
                    },
                    {
                        text: 'Edit',
                        tooltipText: 'Edit',
                        prefixIcon: 'e-edit',
                        id: 'EditDerivedCurve',
                        disabled: !this.hasPermission("Permissions.DerivedCurve.Update")
                    },
                    {
                        text: 'Delete',
                        tooltipText: 'Delete',
                        prefixIcon: 'e-delete',
                        id: 'DeleteDerivedCurve',
                        disabled: !this.hasPermission("Permissions.DerivedCurve.Delete")
                    },
                    'ExcelExport'
                ];
            }
        },
        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey, CommandColumn]
        },
        mounted() {
        }
    }
</script>